import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/accessibility-statement"
    path="business/accessibility-statement"
    element={<AsyncPage />}
  />,
];
